import API_URL from "../config";
import axios from "axios";

import { getCookie } from "./../utils/cookies";

export const getNumberOfAvailableTickets = async (eventID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/read/availableTickets/${id}/${iv}/${eventID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const addMissingReservationApi = async (reservationId, selectedDates = {}) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/addMissingReservation/${id}/${iv}/${reservationId}`,
      { selectedDates },
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const verifyReservationId = async (reservationId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/verifyReservation/${id}/${iv}/${reservationId}`,
      {},
      option
    );
    return res.data;
  }
  catch (err) {
    throw err;
  }
}

// export const getAllTicketsApi = async (eventID) => {
//   try {
//     const token = getCookie("T6hVzR7c0g3maM3F");
//     const iv = getCookie("02hfCmUqpk66w4uG");
//     const id = getCookie("3F2Mb2pJ1YRro5Z4");

//     const option = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const res = await axios.get(
//       `${API_URL}/api/V2/tickets/dashboardTickets/${id}/${iv}/${eventID}`,
//       option
//     );
//     return res.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const getAllTicketsApi = async (filterObject, page = 1, limit = 10) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const queryParams = new URLSearchParams();
    if (filterObject?.eventID) {
      queryParams.append("eventID", filterObject.eventID);
    }
    if (filterObject?.date) {
      queryParams.append("date", filterObject.date);
    }
    if (filterObject?.client) {
      queryParams.append("client", filterObject.client);
    }
    if (filterObject?.ticketID) {
      queryParams.append("ticketID", filterObject.ticketID);
    }
    if (filterObject?.online) {
      queryParams.append("online", filterObject.online);
    }
    if (filterObject?.offline) {
      queryParams.append("offline", filterObject.offline);
    }
    if (filterObject?.ticketType) {
      queryParams.append("ticketType", filterObject.ticketType);
    }

    queryParams.append("page", page);
    queryParams.append("limit", limit);

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/dashboardTickets/${id}/${iv}?${queryParams.toString()}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const getAllReservationApi = async (filterObject, page = 1, limit = 10) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const queryParams = new URLSearchParams();

    if (filterObject?.commandeId) {
      queryParams.append("commandeId", filterObject.commandeId);
    }
    if (filterObject?.email) {
      queryParams.append("email", filterObject.email);
    }
    if (filterObject?.eventID) {
      queryParams.append("eventID", filterObject.eventID);
    }

    if (filterObject?.fullName) {
      queryParams.append("fullName", filterObject.fullName);
    }

    if (filterObject?.reservationDate) {
      const dateValue =
        typeof filterObject.reservationDate === "string"
          ? filterObject.reservationDate
          : filterObject.reservationDate instanceof Date
          ? filterObject.reservationDate.toISOString().split("T")[0]
          : null;

      if (dateValue) {
        queryParams.append("reservationDate", dateValue);
      } else {
        console.warn("Invalid reservationDate format provided:", filterObject.reservationDate);
      }
    }

    if (
      filterObject?.reservationType &&
      (filterObject.reservationType === "online" || filterObject.reservationType === "offline")
    ) {
      queryParams.append("reservationType", filterObject.reservationType);
    }

    queryParams.append("page", page);
    queryParams.append("limit", limit);
    queryParams.append("_", Date.now());

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/dashboardReservations/${id}/${iv}?${queryParams.toString()}`,
      option
    );

    return res.data;
  } catch (err) {
    console.error("Error in getAllReservationApi:", err);
    throw err;
  }
};

// export const getAllReservationApi = async (filterObject, page = 1, limit = 10) => {
//   try {
//     const token = getCookie("T6hVzR7c0g3maM3F");
//     const iv = getCookie("02hfCmUqpk66w4uG");
//     const id = getCookie("3F2Mb2pJ1YRro5Z4");

//     const option = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const queryParams = new URLSearchParams();
//     if (filterObject?.commandeId) {
//       queryParams.append("commandeId", filterObject.commandeId);
//     }
//     if (filterObject?.email) {
//       queryParams.append("email", filterObject.email);
//     }
//     if (filterObject?.eventId) {
//       queryParams.append("eventId", filterObject.eventId);
//     }

//     queryParams.append("page", page);
//     queryParams.append("limit", limit);

//     const res = await axios.get(
//       `${API_URL}/api/V2/tickets/dashboardReservations/${id}/${iv}?${queryParams.toString()}`,
//       option
//     );
//     return res.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const getOneReservationDetails = async (commandeID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/dashboardOneReservation/${id}/${iv}/${commandeID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const resetBuyInfoApi = async (ticketID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/resetTicketBuyInfo/${id}/${iv}/${ticketID}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const resetScanInfoApi = async (ticketID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/resetTicketScanInfo/${id}/${iv}/${ticketID}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const deleteTicketApi = async (ticketID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.delete(
      `${API_URL}/api/V2/tickets/resetAllTicketInfo/${id}/${iv}/${ticketID}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const downloadTicketApi = (ticketID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    return `${API_URL}/api/V2/pdf/adminTicket/download/${id}/${iv}/${token}/${ticketID}`;
  } catch (err) {
    throw err;
  }
};
export const downloadTicketApi2 = (ticketID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    return `${API_URL}/api/V2/pdf/ticket/download/${ticketID}/lmeetup_ticket`;
  } catch (err) {
    throw err;
  }
};

// export const sendCommandeTicketsToMailApi = async (commandeBodyData) => {
//   try {
//     const token = getCookie("T6hVzR7c0g3maM3F");
//     const iv = getCookie("02hfCmUqpk66w4uG");
//     const id = getCookie("3F2Mb2pJ1YRro5Z4");

//     const option = {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const bodyData = {
//       commandeDetails: commandeBodyData,
//     };

//     const res = await axios.post(
//       `${API_URL}/api/V2/tickets/sendReservationMail/${id}/${iv}`,
//       bodyData,
//       option
//     );
//     return res.data;
//   } catch (err) {
//     throw err;
//   }
// };

export const sendCommandeTicketsToMailApi = async (commandeBodyData, targetEmail) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const bodyData = {
      commandeDetails: commandeBodyData,
      targetEmail: targetEmail,
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/sendReservationMail/${id}/${iv}`,
      bodyData,
      option
    );

    return res.data;
  } catch (err) {
    console.error("Error in sendCommandeTicketsToMailApi:", err);
    throw err;
  }
};

export const sendNewReservationEmailApi = async (commandeDetails, tickets, targetEmail) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const bodyData = {
      commandeDetails: {
        commandeDetails: commandeDetails,
        tickets: tickets,
      },
      targetEmail: targetEmail,
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/sendNewReservationEmail/${id}/${iv}`,
      bodyData,
      option
    );

    return res.data;
  } catch (err) {
    console.error("Error in sendNewReservationEmailApi:", err);
    throw err;
  }
};

export const addNewReservationApi = async (bodyData) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/addNewReservation/${id}/${iv}`,
      bodyData,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const previewFixSelectedTimeIdApi = async (ticketId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/previewFixSelectedTimeId/${id}/${iv}/${ticketId}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const applyFixSelectedTimeIdApi = async (ticketId, selectedTimeId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.patch(
      `${API_URL}/api/V2/tickets/applyFixSelectedTimeId/${id}/${iv}/${ticketId}`,
      { selectedTimeId },
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const previewFixReservationTimeIdApi = async (commandeId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/previewFixReservationTimeId/${id}/${iv}/${commandeId}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const applyFixReservationTimeIdApi = async (commandeId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.patch(
      `${API_URL}/api/V2/tickets/applyFixReservationTimeId/${id}/${iv}/${commandeId}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const fixAllEventReservationsTimeIdApi = async (eventId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.patch(
      `${API_URL}/api/V2/tickets/fixAllEventReservationsTimeId/${id}/${iv}/${eventId}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const previewFixAllEventReservationsTimeIdApi = async (eventId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API_URL}/api/V2/tickets/previewFixAllEventReservationsTimeId/${id}/${iv}/${eventId}`,
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const updateTicketBuyFromApi = async (ticketID, buyFrom) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.put(
      `${API_URL}/api/V2/tickets/update/${id}/${iv}/${ticketID}`,
      { buyFrom },
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const cancelReservationApi = async (reservationID) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(
      `${API_URL}/api/V2/tickets/cancelReservation/${id}/${iv}/${reservationID}`,
      {},
      option
    );
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const readFixTicketsSheetApi = async () => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const option = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.get(
    `${API_URL}/api/V2/tickets/readFixTicketsSheet/${id}/${iv}`,
    option
  );
  return res.data;
};

export const processFixTicketsSheetApi = async (eventID) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const option = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(
    `${API_URL}/api/V2/tickets/processFixTicketsSheet/${id}/${iv}/${eventID}`,
    {},
    option
  );
  return res.data;
};

export const debugUserTicketsApi = async (eventID, email) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.get(
    `${API_URL}/api/V2/tickets/debugUserTickets/${id}/${iv}/${eventID}/${encodeURIComponent(email)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const reduceAvailableTicketsApi = async (eventID, reduceBy, ticketSiegeId, selectedTimeId) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/reduceAvailableTickets/${id}/${iv}/${eventID}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      data: { reduceBy, ticketSiegeId, selectedTimeId },
    }
  );
  return res.data;
};

export const deleteTicketsBySiegeApi = async (eventID, ticketSiegeId) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/deleteTicketsBySiege/${id}/${iv}/${eventID}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      data: { ticketSiegeId },
    }
  );
  return res.data;
};

export const deleteAllAvailableTicketsApi = async (eventID) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/deleteAllAvailableTickets/${id}/${iv}/${eventID}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};

export const deleteTicketsNotInTimeIdsApi = async (eventID, validTimeIds) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/deleteTicketsNotInTimeIds/${id}/${iv}/${eventID}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      data: { validTimeIds },
    }
  );
  return res.data;
};

export const deleteTicketsByTimeIdApi = async (eventID, selectedTimeIds) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/deleteTicketsByTimeId/${id}/${iv}/${eventID}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      data: { selectedTimeIds },
    }
  );
  return res.data;
};

export const fixOrphanedTicketsApi = async (eventID, selectedTimeId) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.delete(
    `${API_URL}/api/V2/tickets/fixOrphanedTickets/${id}/${iv}/${eventID}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      data: { selectedTimeId: selectedTimeId || null },
    }
  );
  return res.data;
};

export const fixEventCinemaTicketsApi = async (eventID) => {
  const token = getCookie("T6hVzR7c0g3maM3F");
  const iv = getCookie("02hfCmUqpk66w4uG");
  const id = getCookie("3F2Mb2pJ1YRro5Z4");

  const res = await axios.patch(
    `${API_URL}/api/V2/tickets/fixEventCinemaTickets/${id}/${iv}/${eventID}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res.data;
};
